// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100px;
    height: 100px;
    border: 20px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loading-container {
    display: grid;
}
.content, .loading-overlay {
    grid-area: 1/1;
}
.loading-overlay {
    margin-left: -10px;
    margin-top: -10px;
    width: calc(100% + 10px);
    height: calc(100% + 10px);
    background-color: rgba(0,0,0,0.1);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-backdrop-filter: blur(2px);
            backdrop-filter: blur(2px);
}`, "",{"version":3,"sources":["webpack://./src/css/loading.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,8DAA8D;IAC9D,sDAAsD;AAC1D;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kCAA0B;YAA1B,0BAA0B;AAC9B","sourcesContent":[".lds-ring {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n}\n\n.lds-ring div {\n    box-sizing: border-box;\n    display: block;\n    position: absolute;\n    width: 100px;\n    height: 100px;\n    border: 20px solid #fff;\n    border-radius: 50%;\n    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    border-color: #fff transparent transparent transparent;\n}\n.lds-ring div:nth-child(1) {\n    animation-delay: -0.45s;\n}\n.lds-ring div:nth-child(2) {\n    animation-delay: -0.3s;\n}\n.lds-ring div:nth-child(3) {\n    animation-delay: -0.15s;\n}\n@keyframes lds-ring {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.loading-container {\n    display: grid;\n}\n.content, .loading-overlay {\n    grid-area: 1/1;\n}\n.loading-overlay {\n    margin-left: -10px;\n    margin-top: -10px;\n    width: calc(100% + 10px);\n    height: calc(100% + 10px);\n    background-color: rgba(0,0,0,0.1);\n    border-radius: 6px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    backdrop-filter: blur(2px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
